const AUproblemStatements = [
  {
    statementId: "AU1",
    problemStatement:
      "In today’s small business environment, daily operations are often managed through spreadsheets and informal communication, leading to inefficiencies and lack of accountability. Imagine a centralized platform that allows business owners to create, assign, and track tasks seamlessly improving productivity and team coordination.",
    exampleFeatures: [
      "Task Creation & Assignment: Create tasks and assign them to team members.",
      "Priority & Deadline Setting: Set importance levels and deadlines for better planning.",
      "Task Status Tracking: Monitor progress (pending, in-progress, completed) in real time.",
      "Team Performance Dashboard: View productivity insights and team performance metrics.",
      "Admin Monitoring Panel: Allows business owners to oversee operations and manage workflows."
    ],
    extracontent:
      "Focus on structured workflow and accountability, not informal task management."
  },
  {
    statementId: "AU2",
    problemStatement:
      "In today’s digital-first world, consistently creating engaging social media videos is challenging for individuals, influencers, and small businesses due to time, creativity, and editing constraints. Imagine a platform that automatically transforms simple inputs like text or images into high-quality, ready-to-post videos making content creation fast, easy, and accessible to everyone.",
    exampleFeatures: [
      "Content Input: Users can provide text prompts, blog content, captions, or images to generate videos.",
      "Script Generation: Automatically converts input into an engaging short-form video script.",
      "Automated Video Creation: Generates videos using relevant visuals, animations, and stock footage.",
      "Platform Optimization: Formats videos for platforms like Reels and Shorts with correct aspect ratios."
    ],
    extracontent:
      "Focus on end-to-end automated video creation, not just editing tools."
  },
  {
    statementId: "AU3",
    problemStatement:
      "In today’s fast-paced travel environment, manual airport check-in procedures often lead to long queues and delays, especially during peak hours. This results in passenger frustration and inefficient airport operations. Imagine a system that enables passengers to complete check-in quickly through self-service kiosks or mobile apps making the boarding process faster and smoother.",
    exampleFeatures: [
      "Self-Service Check-in: Passengers can check in using kiosks or mobile applications.",
      "Digital Boarding Pass: Generate and store boarding passes digitally.",
      "Seat Selection: Allow users to choose or modify seats during check-in.",
      "Baggage Check Integration: Enable tagging and tracking of baggage through the system.",
      "Real-Time Flight Updates: Provide live notifications about boarding time, gate changes, etc.",
      "User Profiles: Store passenger details for faster future check-ins.",
      "Admin Dashboard: Airport staff can monitor passenger flow and system performance."
    ],
    extracontent:
      "Focus on seamless, self-service check-in experience, not manual airport processes."
  },
  {
    statementId: "AU4",
    problemStatement:
      "In today’s world, legal documents are often filled with complex language that is difficult for common people to understand, leading to confusion and poor decision-making. Imagine a tool that instantly simplifies legal documents into clear, easy-to-understand language making legal information accessible to everyone.",
    exampleFeatures: [
      "Document Upload/Input: Users can upload PDFs or paste legal text directly.",
      "Simple Language Conversion: Converts complex legal jargon into plain, easy English.",
      "Bullet Point Summary: Generates concise summaries for quick understanding.",
      "Key Risk Highlighting: Identifies and highlights important clauses and potential risks.",
      "Downloadable Output: Allows users to save simplified versions for future reference."
    ],
    extracontent:
      "Focus on making legal content understandable, not just accessible."
  }
];

export default AUproblemStatements;